// @ts-nocheck
import { useMemo } from "react";

import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";

import {
    getSupportPageType,
    resolveSupportLink,
    SupportLinkIntent,
} from "@store/Framework/Common/Utilities/supportLinkResolver";

const useSupportPageLink = (intent: SupportLinkIntent, productId?: string | null) => {
    const pageLink = usePageLinkByPageType(getSupportPageType(intent));

    return useMemo(() => resolveSupportLink({ pageUrl: pageLink?.url, productId }), [pageLink?.url, productId]);
};

export default useSupportPageLink;
